import * as React from 'react';
import { Field } from 'redux-form';

import { FormCheckbox } from '@inqool/uas-web-core/es/components/controls/Checkbox';

import * as T from '@components/form/Checkbox/_checkboxTypes';

const Checkbox: React.SFC<T.OutterProps & T.InnerProps> = ({ label, ...props }) => (
  <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
    <FormCheckbox {...props} />
    {label && <span>{label}</span>}
  </div>
);

export default Checkbox;

export class CheckboxField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/Checkbox/Checkbox.tsx